module.exports = __webpack_public_path__ + "img/package2.fe04afe3.png";